import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';
import { CheieClaude } from './CheieClaude';

// Cheile prizei (6 octombrie 2026): pagina din care super_admin isi leaga asistentul AI.
//
// Asistentul nu primeste parola si nu primeste o sesiune de om: primeste o cheie proprie a
// prizei, valabila doar la functia `priza` (supabase/functions/priza). Cheia se face AICI, in
// browser, din octeti la intamplare; in baza ajunge doar amprenta ei (SHA-256), deci nici noi
// nu o mai putem arata a doua oara. De ce cheie proprie si nu „Permit" pe un ecran:
// supabase/priza_chei.sql.
//
// Regulile de pe ecran sunt si in baza si in functie: o cheie retrasa nu mai trece, iar ce
// poate o cheie tine de rolul stapanului ei.
//
// Din 12 octombrie 2026 (PRIZA_CLIENTI_PLAN.md), pagina e si a managerului si a contului de
// client, cu trei deosebiri fata de super admin:
//   - nu se bifeaza clienti: cheia managerului lucreaza pe clientii repartizati lui, a
//     clientului doar pe clientul lui (le hotaraste functia, din baza, la fiecare cerere);
//   - o singura cheie activa (aparat de un declansator, supabase/priza_chei_roluri.sql);
//   - la client, bifele cheii au efect doar daca dreptul exista si in fisa lui; pagina spune
//     limpede cand bifa e aprinsa, dar dreptul lipseste.
// Super adminul vede si cheile celorlalti si le poate retrage.

const PREFIX = 'nms_';
export const ADRESA_PRIZA = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/priza`;

function cheieNoua() {
  const octeti = new Uint8Array(32);
  window.crypto.getRandomValues(octeti);
  return PREFIX + [...octeti].map(b => b.toString(16).padStart(2, '0')).join('');
}

async function amprenta(text) {
  const octeti = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(octeti)].map(b => b.toString(16).padStart(2, '0')).join('');
}

function cand(iso) {
  if (!iso) return '';
  // Mereu zi.luna.an si ora de 24: „10/06" din formatul american s-ar citi 10 iunie.
  return new Date(iso).toLocaleString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
}

const carton = { background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 14, padding: '20px 24px', marginBottom: 16 };
const eticheta = { display: 'block', fontSize: 12, fontWeight: 600, color: '#4B5563', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 8 };
const caseta = { width: '100%', padding: '10px 12px', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none', boxSizing: 'border-box' };
const cod = { display: 'block', background: '#F2F8F4', border: '1px solid #D1E8DA', borderRadius: 8, padding: '10px 12px', fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontSize: 13, color: '#111827', overflowWrap: 'anywhere' };

function Copiaza({ text }) {
  const [copiat, setCopiat] = useState(false);
  async function copiaza() {
    try { await navigator.clipboard.writeText(text); setCopiat(true); setTimeout(() => setCopiat(false), 1800); } catch (e) { /* omul o poate selecta de mana */ }
  }
  return <button type="button" className="btn-secundar" style={{ padding: '6px 14px', fontSize: 13 }} onClick={copiaza}>{copiat ? t('cheiPriza', 'copiat') : t('cheiPriza', 'copiaza')}</button>;
}

export default function CheiPriza({ clienti = [], rol = 'super_admin', permisiuni = null }) {
  const eAdmin = rol === 'super_admin';
  const eClient = rol === 'client';
  // Cine e logat, ca sa deosebim cheile lui de ale altora (super adminul le vede pe toate).
  const [euId, setEuId] = useState(null);
  // Stapanii cheilor altora, pentru super admin: user_id -> { nume, rol }.
  const [stapani, setStapani] = useState({});
  const [chei, setChei] = useState(null); // null = se incarca
  const [nume, setNume] = useState('');
  const [alese, setAlese] = useState([]);
  // Dreptul de programare al cheii noi (supabase/priza_drepturi.sql). Nebifat din oficiu: o
  // cheie poate, de la sine, doar sa citeasca si sa puna ciorne.
  const [poatePublica, setPoatePublica] = useState(false);
  // Al doilea drept: raspuns, like, ascundere si blocare la comentarii. Tot nebifat din oficiu.
  const [poateRaspunde, setPoateRaspunde] = useState(false);
  const [seLucreaza, setSeLucreaza] = useState(false);
  const [eroare, setEroare] = useState('');
  // Cheia abia facuta, in clar. Traieste doar aici, pana se inchide caseta.
  const [aratata, setAratata] = useState(null);
  // Clientii unei chei existente, in curs de schimbare: { id, alese } sau null. Ceruta de
  // Luminita pe 12 octombrie 2026 („nu fac 100 de chei cand adaug sau scot pe cineva”): pana
  // atunci clientii se bifau doar la crearea cheii, iar un client nou insemna cheie noua si
  // conector refacut. Baza lasa de la inceput schimbarea listei (supabase/priza_chei.sql), iar
  // functia citeste cheia la fiecare cerere, deci schimbarea se simte pe loc.
  const [schimb, setSchimb] = useState(null);
  // Ce a facut asistentul prin priza (supabase/priza_drepturi.sql). null = se incarca.
  const [jurnal, setJurnal] = useState(null);

  async function incarca() {
    const { data, error } = await supabase
      .from('priza_chei')
      .select('id, user_id, nume, inceput, clienti, creata_la, folosita_la, retrasa_la, poate_publica, poate_raspunde')
      .order('creata_la', { ascending: false });
    if (error) { setEroare(t('cheiPriza', 'eroareIncarcare', { detaliu: error.message })); setChei([]); return; }
    const { data: sesiune } = await supabase.auth.getSession();
    const eu = sesiune && sesiune.session ? sesiune.session.user.id : null;
    setEuId(eu);
    setChei(data || []);
    // Numele stapanilor, doar pentru cheile altora (deci doar la super admin).
    const altii = [...new Set((data || []).map(c => c.user_id).filter(id => id && id !== eu))];
    if (altii.length) {
      const { data: profiluri } = await supabase.from('profiluri').select('user_id, nume, rol').in('user_id', altii);
      const harta = {};
      (profiluri || []).forEach(pr => { harta[pr.user_id] = { nume: pr.nume, rol: pr.rol }; });
      setStapani(harta);
    } else {
      setStapani({});
    }
    // Jurnalul se citeste odata cu cheile, deci si la intoarcerea in fila. Daca pica, pagina
    // ramane buna de folosit: se arata gol, iar eroarea nu acopera cheile.
    const { data: randuri } = await supabase
      .from('priza_jurnal')
      .select('id, la, cheie_nume, client_nume, unealta, rezumat, reusit')
      .order('la', { ascending: false })
      .limit(50);
    setJurnal(randuri || []);
  }

  // Lista se reciteste si cand omul se intoarce in fila: „folosita ultima oara" se schimba in
  // timp ce el e in Claude, iar o lista veche ar arata „nefolosita inca" unei chei deja folosite.
  useEffect(() => {
    incarca();
    window.addEventListener('focus', incarca);
    return () => window.removeEventListener('focus', incarca);
  }, []);

  const numeClient = id => { const c = clienti.find(x => Number(x.id) === Number(id)); return c ? c.nume : `#${id}`; };

  function comuta(id) {
    setAlese(a => (a.includes(id) ? a.filter(x => x !== id) : [...a, id]));
  }

  // Managerul si clientul au o singura cheie activa; a doua e refuzata si de baza.
  const areCheieActiva = (chei || []).some(c => !c.retrasa_la && c.user_id === euId);
  const blocatDeLimita = !eAdmin && areCheieActiva;
  const poateGenera = !seLucreaza && chei !== null && nume.trim().length > 0 && (eAdmin ? alese.length > 0 : !blocatDeLimita);
  // La client: dreptul din fisa, fara de care bifa cheii nu are efect.
  const fisa = permisiuni || {};
  const lipsaInFisa = camp => eClient && fisa[camp === 'poate_publica' ? 'poate_publica' : 'raspunde_inbox'] !== true;

  async function genereaza(e) {
    e.preventDefault();
    if (!poateGenera) return;
    setSeLucreaza(true);
    setEroare('');
    const { data: sesiune } = await supabase.auth.getSession();
    const userId = sesiune && sesiune.session ? sesiune.session.user.id : null;
    const cheie = cheieNoua();
    const { error } = await supabase.from('priza_chei').insert({
      user_id: userId,
      nume: nume.trim(),
      amprenta: await amprenta(cheie),
      inceput: cheie.slice(0, PREFIX.length + 6),
      clienti: eAdmin ? alese : [],
      poate_publica: poatePublica,
      poate_raspunde: poateRaspunde,
    });
    setSeLucreaza(false);
    if (error) { setEroare(t('cheiPriza', 'eroareGenerare', { detaliu: error.message })); return; }
    setAratata({ cheie, nume: nume.trim() });
    setNume('');
    setAlese([]);
    setPoatePublica(false);
    setPoateRaspunde(false);
    incarca();
  }

  // Aprinde sau stinge un drept pe o cheie existenta: `poate_publica` (programare si publicare)
  // sau `poate_raspunde` (comentarii). Aprinderea se confirma: din clipa aceea asistentul poate
  // face lucruri care se vad in public.
  async function comutaDrept(c, camp, confirmare) {
    const nou = !c[camp];
    if (nou && !window.confirm(t('cheiPriza', confirmare, { nume: c.nume }))) return;
    setEroare('');
    const { error } = await supabase.from('priza_chei').update({ [camp]: nou }).eq('id', c.id);
    if (error) { setEroare(t('cheiPriza', 'eroareDrept', { detaliu: error.message })); return; }
    incarca();
  }

  // Scrie lista noua de clienti pe o cheie existenta. Adaugarea se confirma, cu numele celor
  // adaugati: din clipa aceea asistentul ii vede, iar daca are si drepturile aprinse, poate
  // publica sau raspunde si la ei. Scoaterea nu se confirma: doar ia din acces.
  async function salveazaClientii(c) {
    if (!schimb || schimb.id !== c.id || schimb.alese.length === 0) return;
    const inainte = (c.clienti || []).map(Number);
    const adaugati = schimb.alese.filter(id => !inainte.includes(Number(id)));
    if (adaugati.length && !window.confirm(t('cheiPriza', 'confirmaClientiNoi', { nume: c.nume, clienti: adaugati.map(numeClient).join(', ') }))) return;
    setEroare('');
    const { error } = await supabase.from('priza_chei').update({ clienti: schimb.alese }).eq('id', c.id);
    if (error) { setEroare(t('cheiPriza', 'eroareClienti', { detaliu: error.message })); return; }
    setSchimb(null);
    incarca();
  }

  async function retrage(c) {
    if (!window.confirm(t('cheiPriza', 'confirmaRetragere', { nume: c.nume }))) return;
    setEroare('');
    const { error } = await supabase.from('priza_chei').update({ retrasa_la: new Date().toISOString() }).eq('id', c.id);
    if (error) { setEroare(t('cheiPriza', 'eroareRetragere', { detaliu: error.message })); return; }
    incarca();
  }

  return (
    <div className="pagina" style={{ maxWidth: 860 }}>
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('cheiPriza', 'titlu')}</h1>
          <p className="pagina-subtitlu">{t('cheiPriza', 'subtitlu')}</p>
        </div>
      </div>

      {!eAdmin && (
        <div style={{ ...carton, background: '#F2F8F4' }}>
          <p style={{ fontSize: 14, color: '#111827', lineHeight: 1.6, margin: 0 }}>{t('cheiPriza', eClient ? 'scopClient' : 'scopManager')}</p>
        </div>
      )}

      {/* Cheia Claude a clientului, pusa de el insusi (15 oct 2026). */}
      {eClient && clienti.length > 0 && <CheieClaude clientId={clienti[0].id} rol="client" />}
      {eroare && <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>{eroare}</div>}

      {aratata && (
        <div style={{ ...carton, borderColor: '#1A6B3C' }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 6 }}>{t('cheiPriza', 'cheiaTa', { nume: aratata.nume })}</div>
          <p style={{ fontSize: 13, color: '#B45309', lineHeight: 1.5, margin: '0 0 12px' }}>{t('cheiPriza', 'oSinguraData')}</p>
          <span style={eticheta}>{t('cheiPriza', 'cheia')}</span>
          <code style={cod}>{aratata.cheie}</code>
          <div style={{ margin: '8px 0 16px' }}><Copiaza text={aratata.cheie} /></div>
          <span style={eticheta}>{t('cheiPriza', 'adresa')}</span>
          <code style={cod}>{ADRESA_PRIZA}</code>
          <div style={{ margin: '8px 0 16px' }}><Copiaza text={ADRESA_PRIZA} /></div>
          <span style={eticheta}>{t('cheiPriza', 'antet')}</span>
          <code style={cod}>Authorization: Bearer {aratata.cheie}</code>
          <div style={{ margin: '8px 0 16px' }}><Copiaza text={`Bearer ${aratata.cheie}`} /></div>
          <p style={{ fontSize: 13, color: '#374151', lineHeight: 1.6, margin: '0 0 14px' }}>{t('cheiPriza', 'cumOPui')}</p>
          <button type="button" className="btn-principal" onClick={() => setAratata(null)}>{t('cheiPriza', 'amCopiat')}</button>
        </div>
      )}

      <form onSubmit={genereaza} style={carton}>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 14 }}>{t('cheiPriza', 'cheieNoua')}</div>
        <label style={eticheta} htmlFor="cheie-nume">{t('cheiPriza', 'nume')}</label>
        <input id="cheie-nume" style={{ ...caseta, marginBottom: 16 }} value={nume} onChange={e => setNume(e.target.value)} placeholder={t('cheiPriza', 'numeExemplu')} maxLength={60} />
        {eAdmin && (<>
        <span style={eticheta}>{t('cheiPriza', 'clienti')}</span>
        <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.5, margin: '0 0 10px' }}>{t('cheiPriza', 'clientiTxt')}</p>
        <div style={{ border: '1.5px solid #D1E8DA', borderRadius: 10, maxHeight: 240, overflowY: 'auto', marginBottom: 16 }}>
          {clienti.length === 0 && <div style={{ padding: '12px 14px', fontSize: 13, color: '#4B5563' }}>{t('cheiPriza', 'niciunClient')}</div>}
          {clienti.map((c, i) => (
            <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', fontSize: 14, color: '#111827', cursor: 'pointer', borderTop: i ? '1px solid #E4EFE8' : 'none' }}>
              <input type="checkbox" checked={alese.includes(c.id)} onChange={() => comuta(c.id)} style={{ width: 16, height: 16, accentColor: '#1A6B3C' }} />
              {c.nume}
            </label>
          ))}
        </div>
        </>)}
        {blocatDeLimita && <p style={{ fontSize: 13, color: '#B45309', lineHeight: 1.5, margin: '0 0 16px' }}>{t('cheiPriza', 'oSinguraCheie')}</p>}
        <span style={eticheta}>{t('cheiPriza', 'drepturi')}</span>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: '#111827', cursor: 'pointer', marginBottom: 6 }}>
          <input type="checkbox" checked={poatePublica} onChange={e => setPoatePublica(e.target.checked)} style={{ width: 16, height: 16, marginTop: 3, accentColor: '#1A6B3C' }} />
          {t('cheiPriza', 'dreptPublicare')}
        </label>
        <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.5, margin: '0 0 12px 26px' }}>{t('cheiPriza', 'dreptPublicareTxt')}</p>
        {lipsaInFisa('poate_publica') && <p style={{ fontSize: 13, color: '#B45309', lineHeight: 1.5, margin: '-6px 0 12px 26px' }}>{t('cheiPriza', 'faraDreptFisaPublicare')}</p>}
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: '#111827', cursor: 'pointer', marginBottom: 6 }}>
          <input type="checkbox" checked={poateRaspunde} onChange={e => setPoateRaspunde(e.target.checked)} style={{ width: 16, height: 16, marginTop: 3, accentColor: '#1A6B3C' }} />
          {t('cheiPriza', 'dreptRaspuns')}
        </label>
        <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.5, margin: '0 0 16px 26px' }}>{t('cheiPriza', 'dreptRaspunsTxt')}</p>
        {lipsaInFisa('poate_raspunde') && <p style={{ fontSize: 13, color: '#B45309', lineHeight: 1.5, margin: '-10px 0 16px 26px' }}>{t('cheiPriza', 'faraDreptFisaRaspuns')}</p>}
        <button type="submit" className="btn-principal" disabled={!poateGenera}>{seLucreaza ? t('cheiPriza', 'seGenereaza') : t('cheiPriza', 'genereaza')}</button>
      </form>

      <div style={carton}>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 14 }}>{t('cheiPriza', eAdmin ? 'cheileToate' : 'cheileTale')}</div>
        {chei === null && <div style={{ fontSize: 13, color: '#4B5563' }}>{t('cheiPriza', 'seIncarca')}</div>}
        {chei !== null && chei.length === 0 && <div style={{ fontSize: 13, color: '#4B5563' }}>{t('cheiPriza', 'nicioCheie')}</div>}
        {(chei || []).map((c, i) => (
          <div key={c.id} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', justifyContent: 'space-between', padding: '12px 0', borderTop: i ? '1px solid #E4EFE8' : 'none', opacity: c.retrasa_la ? 0.75 : 1 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{c.nume} <span style={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontWeight: 400, fontSize: 12, color: '#4B5563' }}>{c.inceput}…</span></div>
              {c.user_id !== euId && (
                <div style={{ fontSize: 13, color: '#0F3D22', fontWeight: 600, marginTop: 2 }}>
                  {t('cheiPriza', 'aLui', { nume: (stapani[c.user_id] && stapani[c.user_id].nume) || '?', rol: t('cheiPriza', (stapani[c.user_id] && stapani[c.user_id].rol) === 'client' ? 'rolClient' : 'rolManager') })}
                </div>
              )}
              {c.user_id === euId && eAdmin && !(schimb && schimb.id === c.id) && (
                <div style={{ fontSize: 13, color: '#374151', marginTop: 2 }}>
                  {(c.clienti || []).map(numeClient).join(', ')}
                  {!c.retrasa_la && (
                    <button type="button" onClick={() => setSchimb({ id: c.id, alese: (c.clienti || []).map(Number) })}
                      style={{ marginLeft: 10, padding: 0, border: 'none', background: 'none', color: '#1A6B3C', fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, textDecoration: 'underline', cursor: 'pointer' }}>
                      {t('cheiPriza', 'schimbaClientii')}
                    </button>
                  )}
                </div>
              )}
              {c.user_id === euId && eAdmin && schimb && schimb.id === c.id && (
                <div style={{ marginTop: 8 }}>
                  <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.5, margin: '0 0 8px' }}>{t('cheiPriza', 'schimbaClientiiTxt')}</p>
                  <div style={{ border: '1.5px solid #D1E8DA', borderRadius: 10, maxHeight: 240, overflowY: 'auto', marginBottom: 10 }}>
                    {clienti.map((cl, j) => (
                      <label key={cl.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px', fontSize: 14, color: '#111827', cursor: 'pointer', borderTop: j ? '1px solid #E4EFE8' : 'none' }}>
                        <input type="checkbox" checked={schimb.alese.includes(Number(cl.id))}
                          onChange={() => setSchimb(s => ({ ...s, alese: s.alese.includes(Number(cl.id)) ? s.alese.filter(x => x !== Number(cl.id)) : [...s.alese, Number(cl.id)] }))}
                          style={{ width: 16, height: 16, accentColor: '#1A6B3C' }} />
                        {cl.nume}
                      </label>
                    ))}
                  </div>
                  {schimb.alese.length === 0 && <p style={{ fontSize: 13, color: '#B45309', lineHeight: 1.5, margin: '0 0 10px' }}>{t('cheiPriza', 'macarUnClient')}</p>}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button type="button" className="btn-principal" style={{ padding: '7px 16px', fontSize: 13 }} disabled={schimb.alese.length === 0} onClick={() => salveazaClientii(c)}>{t('cheiPriza', 'salveazaClientii')}</button>
                    <button type="button" className="btn-secundar" style={{ padding: '7px 16px', fontSize: 13 }} onClick={() => setSchimb(null)}>{t('cheiPriza', 'renuntaClientii')}</button>
                  </div>
                </div>
              )}
              <div style={{ fontSize: 12, color: '#4B5563', marginTop: 4 }}>
                {t('cheiPriza', 'creata', { cand: cand(c.creata_la) })} · {c.folosita_la ? t('cheiPriza', 'folosita', { cand: cand(c.folosita_la) }) : t('cheiPriza', 'nefolosita')}
              </div>
              {!c.retrasa_la && c.user_id !== euId && (
                <div style={{ fontSize: 13, color: '#374151', marginTop: 6 }}>
                  {[c.poate_publica && t('cheiPriza', 'dreptPublicare'), c.poate_raspunde && t('cheiPriza', 'dreptRaspuns')].filter(Boolean).join(' · ') || t('cheiPriza', 'doarCiorne')}
                </div>
              )}
              {!c.retrasa_la && c.user_id === euId && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#111827', cursor: 'pointer', marginTop: 8 }}>
                  <input type="checkbox" checked={!!c.poate_publica} onChange={() => comutaDrept(c, 'poate_publica', 'confirmaDrept')} style={{ width: 16, height: 16, accentColor: '#1A6B3C' }} />
                  {t('cheiPriza', 'dreptPublicare')}
                </label>
              )}
              {!c.retrasa_la && c.user_id === euId && c.poate_publica && lipsaInFisa('poate_publica') && (
                <div style={{ fontSize: 12.5, color: '#B45309', lineHeight: 1.5, margin: '2px 0 0 24px' }}>{t('cheiPriza', 'faraDreptFisaPublicare')}</div>
              )}
              {!c.retrasa_la && c.user_id === euId && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#111827', cursor: 'pointer', marginTop: 6 }}>
                  <input type="checkbox" checked={!!c.poate_raspunde} onChange={() => comutaDrept(c, 'poate_raspunde', 'confirmaDreptRaspuns')} style={{ width: 16, height: 16, accentColor: '#1A6B3C' }} />
                  {t('cheiPriza', 'dreptRaspuns')}
                </label>
              )}
              {!c.retrasa_la && c.user_id === euId && c.poate_raspunde && lipsaInFisa('poate_raspunde') && (
                <div style={{ fontSize: 12.5, color: '#B45309', lineHeight: 1.5, margin: '2px 0 0 24px' }}>{t('cheiPriza', 'faraDreptFisaRaspuns')}</div>
              )}
            </div>
            {c.retrasa_la
              ? <span style={{ fontSize: 12, fontWeight: 600, color: '#B91C1C', whiteSpace: 'nowrap' }}>{t('cheiPriza', 'retrasa', { cand: cand(c.retrasa_la) })}</span>
              : <button type="button" className="btn-sterge-profil" onClick={() => retrage(c)}>{t('cheiPriza', 'retrage')}</button>}
          </div>
        ))}
      </div>

      <div style={carton}>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 4 }}>{t('cheiPriza', 'jurnalTitlu')}</div>
        <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.5, margin: '0 0 14px' }}>{t('cheiPriza', 'jurnalTxt')}</p>
        {jurnal === null && <div style={{ fontSize: 13, color: '#4B5563' }}>{t('cheiPriza', 'seIncarca')}</div>}
        {jurnal !== null && jurnal.length === 0 && <div style={{ fontSize: 13, color: '#4B5563' }}>{t('cheiPriza', 'jurnalGol')}</div>}
        {(jurnal || []).map((j, i) => (
          <div key={j.id} style={{ display: 'grid', gridTemplateColumns: '112px minmax(0, 1fr)', gap: 12, padding: '10px 0', borderTop: i ? '1px solid #E4EFE8' : 'none' }}>
            <div style={{ fontSize: 12, color: '#4B5563', fontVariantNumeric: 'tabular-nums' }}>{cand(j.la)}</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13, color: '#111827', fontWeight: 600 }}>
                {j.client_nume || t('cheiPriza', 'jurnalFaraClient')}
                {!j.reusit && <span style={{ marginLeft: 8, fontSize: 12, fontWeight: 600, color: '#B91C1C' }}>{t('cheiPriza', 'jurnalRefuzat')}</span>}
              </div>
              <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.5, overflowWrap: 'anywhere' }}>{j.rezumat}</div>
              <div style={{ fontSize: 12, color: '#4B5563', marginTop: 2 }}>{j.cheie_nume}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
